import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Button as KitButton } from '@cian/ui-kit/button';
import { jsx as _jsx } from "react/jsx-runtime";
export var Button = function Button(_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    onClick = _ref.onClick,
    buttonText = _ref.buttonText,
    phoneButtonTestId = _ref.phoneButtonTestId;
  return /*#__PURE__*/_jsx(KitButton, _objectSpread(_objectSpread({}, styles), {}, {
    "data-testid": phoneButtonTestId,
    onClick: onClick,
    children: buttonText
  }));
};